/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps, IconSize} from '../../types/types';
import useIconDLS from './../useIconDLS';

/*
 * Defines the Design Language System (DLS) Asset Train-Outline Icon component.
 */
export const AssetTrainOutlineIcon = (props: IconProps) => {
  const {color, size = IconSize.large, stroke} = props;
  const {iconSize} = useIconDLS({color, size});
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 40 40' fill='none'>
      <line x1="5.87549" y1="27.7402" x2="32.7646" y2="27.7402" stroke={stroke as any} strokeWidth="1.5"/>
      <path d="M6.49854 16.4502H16.0984C16.958 16.4502 17.7764 16.819 18.3458 17.4629L24.3309 24.2314" stroke={stroke as any} strokeWidth="1.5"/>
      <path d="M32.4387 24.2084C32.7538 24.1277 33.0487 23.9708 33.3019 23.7489C33.5551 23.5271 33.7603 23.246 33.9025 22.9259C34.0447 22.6059 34.1203 22.2551 34.124 21.8988C34.1276 21.5426 34.0592 21.1899 33.9236 20.8665L29.3065 13.1332C29.104 12.649 28.7798 12.2389 28.3722 11.9512C27.9647 11.6635 27.4908 11.5103 27.0066 11.5098L6.49854 11.5098V24.2312L32.4387 24.2084Z" stroke={stroke as any} strokeWidth="1.5"/>
    </svg>
  );
};

export default AssetTrainOutlineIcon;
